<ion-col size="12" sizeXl="6">
  <ion-row *ngIf="_chartTypes.Maaned.active" class="row-m">
    <ion-col>
      <ion-row>
        <ion-col>
          <h2 class="monthTitleText">Kostnader per måned</h2>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="availableYearsForbruk">
        <ion-col size="6" offset="3" class="monthButtonCol">
          <ion-button
            *ngFor="let year of availableYearsForbruk"
            class="hundred"
            [class.selected]="year === selectedDateMonth?.getFullYear()"
            (click)="setSelectedDateMonth(year)"
          >
            {{ year }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row class="row-m">
    <ion-col>
      <!-- Tall for år ikke mobil...-->
      <app-kostnadstall
        *ngIf="!isBrowser && _chartTypes.Aar.active"
        [valgtAnleggMaaned]="valgtMaanedAnlegg"
        [valgtAnleggAar]="valgtAarAnlegg"
        [selectedDate]="selectedDate"
        [valgtTimeAnlegg]="valgtTimeAnlegg"
        [valgtDagAnlegg]="valgtDagAnlegg"
        [valgtAvtale]="valgtAvtale"
        [isStromstotteToggled]="isStromstotteToggled"
        [selectedDateMonth]="selectedDateMonth"
      ></app-kostnadstall>

      <!-- Charts -->
      <app-chart-kostnad
        [isBrowser]="isBrowser"
        [hasFetchingError]="hasFetchingError"
        [valgtAarAnlegg]="valgtAarAnlegg"
        [minDate]="minDate"
        [valgtMaanedAnlegg]="valgtMaanedAnlegg"
        [selectedDateMonth]="selectedDateMonth"
        [valgtDagAnlegg]="valgtDagAnlegg"
        [selectedDateDay]="selectedDateDay"
        [valgtTimeAnlegg]="valgtTimeAnlegg"
        [selectedDateHour]="selectedDateHour"
        [isStromstotteToggled]="isStromstotteToggled"
      ></app-chart-kostnad>

      <!-- TALL UNDER GRAF -->
      <app-kostnadstall
        *ngIf="
          _chartTypes.Time.active ||
          _chartTypes.Dag.active ||
          _chartTypes.Maaned.active
        "
        [valgtAnleggMaaned]="valgtMaanedAnlegg"
        [valgtAnleggAar]="valgtAarAnlegg"
        [selectedDate]="selectedDate"
        [valgtTimeAnlegg]="valgtTimeAnlegg"
        [valgtDagAnlegg]="valgtDagAnlegg"
        [valgtAvtale]="valgtAvtale"
        [selectedDateHour]="selectedDateHour"
        [isStromstotteToggled]="isStromstotteToggled"
        [selectedDateMonth]="selectedDateMonth"
      ></app-kostnadstall>
    </ion-col>
  </ion-row>
</ion-col>
